import { axiosInstance } from '@/lib/utils';
import type { StoreCreationPayload } from './payload';
import { endpoints } from '@/api';
import type { RequestResponse, Store } from '@/types';

export const createStore = async (payload: StoreCreationPayload) => {
  const response = await axiosInstance.post<RequestResponse<Store>>(
    endpoints.stores,
    payload
  );
  return response.data;
};

export const updateStore = async ({
  id,
  ...payload
}: Partial<StoreCreationPayload> & { id?: string }) => {
  const response = await axiosInstance.patch<RequestResponse<Store>>(
    `${endpoints.stores}/${id}`,
    payload
  );
  return response.data;
};
